import type { ProductVariantsQueryParams } from '@lingoda/api';
import { createAction, makeActionTrackable } from '@lingoda/core';
import type { Product, ProductVariant } from './models';

export const addProducts = createAction<Product[]>('product/ADD_PRODUCTS');
export const addProductVariants = createAction<ProductVariant[]>('product/ADD_PRODUCT_VARIANTS');
export const fetchProductVariants = makeActionTrackable(
    createAction<ProductVariantsQueryParams>('product/FETCH_PRODUCT_VARIANTS'),
);
